const AllApis = {
    addressDropdown: {
        add: function (type) {
            return `/address/dropdown/create/${type}`;
        },
        get: function (type) {
            return `/address/dropdown/get/${type}`;
        },
    },
    marketExective: {
        add: `/myProfile`,
        list: `/myProfile/getAllMet`,
        dropdown: `/myProfile/dropdown/list`,
        getById: function () {
            return `/myProfile`;
        },
        update: function () {
            return `/myProfile`;
        },
        uploadFile: function () {
            return `/myProfile/uploadImage`;
        },
        nominee: {
            add: function () {
                return `/myProfile/nominee/add`;
            },
            update: function (nomineeId) {
                return `/myProfile/nominee/update/${nomineeId}`;
            },
        },
    },
    Auth: {
        login: `/auth/login`,
        verifyOtp: `/auth/verifyotp`,
        forgetPassword: `/auth/forgotpassword`,
        updatePassword: `/auth/updatePassword`
    },
    store: {
        mtStore: `/metStore`
    },
    transaction: {
        transactionHistory: "/transactionHistory"
    }
}
export default AllApis